import {Button, message, Modal} from 'antd'
import {course_getCourseSubjects_Api, course_getSubjectById_Api, course_getSubjects_Api, subjectSchema,} from 'apis'
import {getId} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {useLocation} from 'react-use'
import {branch, compose, withProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {SubjectActionTypes} from 'views/AppLocals/Course'
import {CreateSubjectModal, EditSubjectModal,} from 'views/AppLocals/Course/Subject/SubjectForm'
import {useSubject} from 'views/AppLocals/Course/Subject/useSubject'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {getResponseItem, NullAsDefault, renderTrue} from 'views/Shared'
import {renderSubjectCardItem, renderSubjectTableRow} from '../functions/renderSubject'
import getTitle from "../../../../helpers/getTitle";
import {renderElse, renderIf} from "../../../Shared";
import {convertFromString, isEmptyContent} from "../../../SlateEditor/functions";
import {SlateRenderer} from "../../../SlateEditor";
import {FetchSubjectById} from "../../../AppLocals/Course/components/FetchEntity";
import {RiSearchEyeLine} from "react-icons/ri";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {GoDotFill} from "react-icons/go";
import copyToClipboard from "copy-to-clipboard";
import {IoCopyOutline} from "react-icons/io5";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {BsGrid3X3GapFill, BsTable} from "react-icons/bs";
import PagePaginationWrapper from "../../../../modules/asyncCache/components/PagePagination/PagePaginationWrapper";
import EmptyHolder from "../../../../components/EmptyHolder";
import {renderLoading} from "../../../AppLocals/functions/renderers/renderLoading";


const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const SubjectsManager = ({
                             owner_id,
                             owner_type,
                             Header = NullAsDefault,
                             filter_option = renderTrue,
                         }) => {
    const t = useTranslate()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    // Bảng mặc định (theo yêu cầu), người dùng tự chuyển sang Thẻ qua toggle - chỉ local state,
    // không đưa vào URL. Khớp pattern viewMode ở Students.js/Parents.js/Teachers.js cùng thư mục.
    const [viewMode, setViewMode] = useState('table')

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const {
        refreshKey,
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
    } = useSubject({
        onCreated: onCancel,
        onUpdated: onCancel,
        onDeleted: onCancel,
    })

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete subject',
                message: 'are you sure you want to delete subject of class',
                onOk: () => {
                    onDelete({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        switch (action) {
            case SubjectActionTypes.SUBJECT_READ:
                setAction({type: action, value: params});
                break
            case SubjectActionTypes.SUBJECT_UPDATE:
            case SubjectActionTypes.SUBJECT_CREATE:
                setAction({type: action, value: params});
                break
            case SubjectActionTypes.SUBJECT_DELETE:
                confirmDelete(params?.id)
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view detail',
                        key: SubjectActionTypes.SUBJECT_READ,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: SubjectActionTypes.SUBJECT_UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: SubjectActionTypes.SUBJECT_DELETE,
                    },
                ].filter(filter_option),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const DetailSubjectModalContent = ({item}) => {
        const t = useTranslate()
        const {about, description, number_of_sessions, subject_idcode, hashtags} = item ?? {}
        const tags = (hashtags || '').split(',').filter((e) => !!e)
        return (
            <div className="p-4 flex flex-col gap-4">
                <div className="border-b border-blue-300 pb-1 font-bold text-xl text-blue-600 tracking-wide">
                    {getTitle(item)}
                </div>
                <div className="flex flex-col gap-2">
                    {renderIf(
                        subject_idcode,
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-3">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-sm text-color-400 italic whitespace-nowrap">
                                    {`${t('subject code')}: `}
                                </span>
                            </div>
                            <span
                                onClick={() => {
                                    copyToClipboard(subject_idcode)
                                    message.info(t('copied'))
                                }}
                                className="flex-1 font-semibold text-color-100 hover:text-color-000 cursor-pointer tracking-wide">
                                {`#${subject_idcode}`}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                        </div>
                    )}
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-3">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-sm text-color-400 italic whitespace-nowrap">
                                {`${t('number of sessions')}: `}
                            </span>
                        </div>
                        <span
                            className="w-fit px-3 border border-blue-400 bg-blue-50 rounded-full font-medium text-xs text-blue-500 italic">
                             {`${number_of_sessions} ${t('sessions')}`}
                        </span>
                    </div>
                    {renderIf(
                        tags.length > 0,
                        <div className="flex flex-wrap items-center gap-1.5">
                            {tags.map((tag) => (
                                <span
                                    key={tag}
                                    style={{padding: '1px 8px'}}
                                    className="rounded-full font-medium text-2xs text-color-300 bg-color-50 tracking-wide">
                                    {`#${tag}`}
                                </span>
                            ))}
                        </div>
                    )}
                    {renderIf(
                        description,
                        <div className="flex flex-col">
                            <div className="flex items-center gap-3">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-sm text-color-400 italic whitespace-nowrap">
                                    {`${t('description')} : `}
                                </span>
                            </div>
                            <div className="ml-3 text-color-200 tracking-wider whitespace-pre-line">
                                {description}
                            </div>
                        </div>
                    )}
                    {renderElse(
                        isEmptyContent(about),
                        <div className="flex flex-col">
                        <span className="text-sm text-color-400">
                          {`${t('introduce')} : `}
                        </span>
                            <SlateRenderer value={convertFromString(about)}/>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}

        switch (action?.type) {
            case SubjectActionTypes.SUBJECT_READ:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view detail')}
                    </div>
                )
                params = {
                    item: action?.value
                }
                modal_params = {
                    width: 600,
                    footer: undefined,
                    cancelText: t('close'),
                    okButtonProps: {
                        hidden: true,
                    },
                    cancelButtonProps: {
                        className: 'text-color-400 button-rounded-lg no-border',
                    },
                }
                Content = DetailSubjectModalContent
                Wrapper = withProps({id})(FetchSubjectById)
                break
            case SubjectActionTypes.SUBJECT_CREATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('create subject')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values, {
                            id: owner_id,
                            type: owner_type,
                        })
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = CreateSubjectModal
                break
            case SubjectActionTypes.SUBJECT_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('edit subject')}
                    </div>
                )
                params = {
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                modal_params = {
                    width: 720,
                }
                Content = ({initialValues, ...rest}) => (
                    <SelectEntityItem
                        schema={subjectSchema}
                        item={getId(initialValues)}
                        defaultItem={initialValues}>
                        {(item) => (
                            <EditSubjectModal
                                {...rest}
                                initialValues={item}
                            />
                        )}
                    </SelectEntityItem>
                )
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: course_getSubjectById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const query_params = {sortBy: 'sort-by', keyword: 'keyword', hashtags: 'hashtags'}

    // Bảng: cột MÔN HỌC (gộp cả mô tả) | MÃ MÔN HỌC | SỐ TIẾT HỌC | THAO TÁC - khớp cột với
    // renderSubjectTableRow (renderSubject.js).
    const TABLE_COLUMNS = [
        {label: t('subject'), className: 'text-left'},
        {label: t('subject code'), className: 'text-left'},
        {label: t('number sessions'), className: 'text-left'},
        {label: t('actions'), className: 'text-right'},
    ]

    const renderList = useCallback(
        ({keyword, sortBy: currentSort, filterBy, refreshKey}) => (
            <PagePaginationWrapper
                apiInfo={course_getSubjects_Api}
                query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
                values={{keyword, sort_by: currentSort, ...(filterBy ?? {})}}
                refreshKey={refreshKey}
                renderItem={
                    viewMode === 'table'
                        ? renderSubjectTableRow({translate: t, renderContextMenu, handleAction})
                        : renderSubjectCardItem({translate: t, renderContextMenu, handleAction})
                }
                renderLoading={() => renderLoading()}
                renderEmpty={() => <EmptyHolder/>}
                Wrapper={({children}) => viewMode === 'table' ? (
                    <div className="mt-2 w-full overflow-x-auto rounded-xl border border-color-50">
                        <table className="w-full" style={{borderCollapse: 'collapse'}}>
                            <thead>
                                <tr className="background-200">
                                    {TABLE_COLUMNS.map((col, i) => (
                                        <th key={i} className={classNames("px-3 py-2 text-2xs font-bold text-color-400 uppercase tracking-wider whitespace-no-wrap", col.className)}>
                                            {col.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>{children}</tbody>
                        </table>
                    </div>
                ) : (
                    <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                        {children}
                    </div>
                )}
            />
        ),
        [owner_id, owner_type, t, renderContextMenu, handleAction, viewMode]
    )

    const viewModeToggle = (
        <div className="flex items-center flex-shrink-0 rounded-lg border border-color-200 overflow-hidden">
            <button
                type="button"
                title={t('table')}
                onClick={() => setViewMode('table')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors",
                    viewMode === 'table' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsTable size={14}/>
            </button>
            <button
                type="button"
                title={t('card')}
                onClick={() => setViewMode('card')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors border-l border-color-200",
                    viewMode === 'card' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsGrid3X3GapFill size={14}/>
            </button>
        </div>
    )

    const [pager_widget] = usePaginationHelper({
        renderList,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        // Toggle Bảng/Thẻ đặt giữa ô search và nút Lọc (renderHeader) - KHÔNG đụng search bar hay
        // nút Lọc (ButtonAdvance do ListFilter tự render ngoài renderHeader).
        renderHeader: ([search_bar]) => (
            <div className="flex items-center gap-2">
                <div className="flex-1 min-w-0">{search_bar}</div>
                {viewModeToggle}
            </div>
        ),
        // AdvancedFilter: SubjectFilter,
        query_params,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
    })

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('subject library')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 text-sm text-color-300 tracking-wider">
                        {t('this is the subject library used to build course content manage documents sample lectures and assessment standards')}
                    </div>
                </div>
                <Button
                    color="primary" variant="solid"
                    className="px-6 py-2 font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(SubjectActionTypes.SUBJECT_CREATE)
                    }}>
                    {t('create subject')}
                </Button>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}

const AdvancedHeader = withProps({description: 'note subject description'})(
    ListHeader
)

const Subjects = compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    ),
    withProps(() => ({
        Header: AdvancedHeader,
    }))
)(SubjectsManager)

export const CourseSubjectsManager = compose(
    branch(
        ({course_id}) => !course_id,
        () => () => <ContentNotFound/>
    ),
    withProps(({course_id}) => ({
        Header: ListHeader,
        apiInfo: course_getCourseSubjects_Api,
        query: bindQueryParam({id: course_id}),
    }))
)(SubjectsManager)

export default Subjects
